<template>
<div>


    <v-layout style="margin-left: 10px;padding:0px; margin-right: 0px;" row wrap>
      <v-list >
        <template v-for="item in handleidingen" >
          <v-list-tile @click.native="clickFile(item)"  style="margin: 0px; padding: 0px;border-style: solid;border-width: 1px;">
            <v-list-tile-content>
              {{item.title}}
            </v-list-tile-content>
          </v-list-tile>

        </template>
      </v-list>
    <v-container style="margin: 0px;padding:0px;">

    </v-container>

        </v-layout>




</div>


</template>




<script>
import datareq from './datareq.js'
import functions from './functions.js'
  export default {
    components: {
      datareq,
      functions
    },
    created: function () {
      this.$bus.$on('laadHandleidingen', this.laden)
    },
    data () {
      return {
        handleidingen: [],
        naamfilter: ''
      }
    },
    methods: {
      laden: function () {
        this.naamfilter = ''
        this.updateFilters()
      },
      clickFile: function (item) {
        //this.$bus.$emit('laadWervenDetail', [{werfnr: werf.werfnr, werfnaam: werf.werfnaam}])
        //this.lijstofdetail = false
      },
      jsonHandleidingenReceived: function (data) {
        var status = data.status
        if (status === 'OK') {
          this.receivedCounter = this.receivedCounter + 1
          var d = data.data
          this.handleidingen = []
          for (var s of d) {
            var n = {title: s, url: s}
            this.handleidingen.push(n)
          }
        } else {
        }
      },
      updateFilters: function () {
        datareq.getData('GetHandleidingenLijst', {}, this.jsonHandleidingenReceived)
        //datareq.getData('GetWerven', {idfilter: this.werfnrfilter, werffilter: this.naamfilter, perpagina : 9999, pagina: 0}, this.jsonWervenReceived)
      }
    }
  }
</script>

<style lang="stylus">
  @import './stylus/main'


</style>


<style scoped>
body {
  font-family: Helvetica Neue, Arial, sans-serif;
  font-size: 14px;
  color: #444;
}

table {
  width: 590px;
  border: 2px solid gray;
  border-radius: 3px;
  background-color: #fff;
  box-shadow: 0px 0px 10px darkgrey;
  border-collapse: collapse;
}

th {
  background-color: #ebebeb;
  color: black;
  -webkit-user-select: none;
  -moz-user-select: none;
  -user-select: none;
  cursor: auto;
}


.topclass {
  padding: 0px;
  padding-top: 0px;
}

.alignright {
  text-align: right;
}

.bold {
  font-weight: bold;
}

tr {
  cursor: pointer;
  text-align: left;
  white-space: pre-wrap;

}

tr:nth-child(odd) {
  background-color: #f2f2f2;
  color: #000000;
}

tr:hover {
  background-color: #cde9ef;
  cursor: pointer;
}

td {
  min-width: 10px;
  padding: 5px 5px;
  margin: 0px;
  border: 1px solid black;
}

.werfnrcol {
  width: 100px;min-width: 90px;max-width: 90px;
}

.naamcol {
  width: 400px;min-width: 400px;max-width: 400px;
}

.machcol {
  width: 90px;min-width: 300px;max-width: 300px;
}

.headercell {
  height: 10px; margin: 0px; padding: 0px;
}

.textfieldcell {
   margin: 0px; padding: 0px;
}

.oranjeachtergrond {
  background-color: orange;
}

.rodeachtergrond {
  background-color: red;
}


</style>



// WEBPACK FOOTER //
// handleidingen.vue?b9db4506